import { FC } from 'react';
import { Outlet } from 'react-router-dom';

export const ReportsPage: FC = () => {
  return <Outlet />;
};
